import * as React from 'react'
import clsx from 'clsx'
import { ColumnsType, Table, TableProps, Tag } from 'components/common'
import { navigate } from 'gatsby'

export interface LedgerItems {
  key: string | number
  title: string
  explanation?: string
  status: string
  createdAt: string
  updatedAt?: string
}
type InternalProps = TableProps<LedgerItems>
type Actions = Pick<InternalProps, 'onChange' | 'onRow'>
export interface LedgerItemsTableProps
  extends Omit<
    InternalProps,
    'pagination' | 'columns' | 'sticky' | 'onChange' | 'onRow'
  > {
  dataSource: Array<LedgerItems>
}

const columns: ColumnsType<LedgerItems> = [
  {
    key: 'title',
    title: 'タイトル',
    dataIndex: 'title',
    ellipsis: true,
  },
  {
    key: 'explanation',
    title: '説明',
    dataIndex: 'explanation',
    ellipsis: true,
  },
  {
    key: 'status',
    title: 'ステータス',
    dataIndex: 'status',
    render: (value) => {
      switch (value) {
        case 'active':
          return <Tag color={'success'}>アクティブ</Tag>
        case 'archived':
          return <Tag color={'gray'}>アーカイブ</Tag>
        default:
          return null
      }
    },
  },
  {
    key: 'createdAt',
    title: '作成日',
    dataIndex: 'createdAt',
  },
  {
    key: 'updatedAt',
    title: '更新日',
    dataIndex: 'updatedAt',
  },
]

export const LedgerItemsTable = ({
  dataSource,
  ...restProps
}: LedgerItemsTableProps): JSX.Element => {
  const onRow: Actions['onRow'] = (record, action) => {
    return {
      onClick: async (event) => {
        await navigate(`./${record.key}`)
      },
      // onDoubleClick: (event) => {},
      // onContextMenu: (event) => {},
      // onMouseEnter: (event) => {},
      // onMouseLeave: (event) => {},
    }
  }
  return (
    <Table
      sticky
      pagination={false}
      rowClassName={clsx('cursor-pointer')}
      dataSource={dataSource}
      columns={columns}
      onRow={onRow}
      {...restProps}
    />
  )
}
